export default __webpack_public_path__ + "static/salesHubVp1-9c2e6edd25f92cab519f5c3505b4b99f.png";